// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__2GHZO","title":"Home_title__idnpY","description":"Home_description__1R4FB","sliderSwitch":"Home_sliderSwitch__3Rh-Z","logoOrcom":"Home_logoOrcom__3VVK4"};